import uajs from './module/ua';

(function ($) {
  const ua = uajs();

  $(document).ready(function () {

    // 769px以上のviewport
    if ($(window).width() > 769) {
      $('meta[name="viewport"]').attr('content', 'width=1200');
    }

    // アンカーリンク
    $('a[href^="#"]').click(function (e) {
      let href = $(this).attr('href');
      if (href.match(/^#/) && $(href).length > 0) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $(href).offset().top
        }, 'fast');
        return false;
      }
    });

    // 別ページへのアンカーリンク（するする）
    $(function () {
      var urlHash = location.hash;
      if (urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
          // ヘッダー固定の場合はヘッダーの高さを数値で入れる、固定でない場合は0（今回はcssで調整してるから0）
          var headerHight = 0;
          var target = $(urlHash);
          var position = target.offset().top - headerHight;
          $('body,html').stop().animate({scrollTop:position}, 400);
        }, 100);
      }
    });

    // Gnavスクロールでclacc追加
    var $header = $(".l-header");
    var headerHeight = $header.outerHeight();
    $(window).scroll(function(){
      if ( $(this).scrollTop() > headerHeight){
        $header.addClass("js-active");
      }else{
        $header.removeClass("js-active");
      }
    });

    // Gnav class追加、スクリーンリーダーでbuttonの開閉を認識
    $('.l-nav__btn.js-gnav').on('click', function (e) {
      $(".l-header__nav").toggleClass("l-nav__contents-open");
      if (window.innerWidth <= 767) {
        e.preventDefault();
        if ($(".l-nav__btn.js-gnav").attr('aria-expanded') == 'true') {
          $(".l-nav__btn.js-gnav").attr('aria-expanded', 'false');
          $(".l-nav__body").attr('aria-hidden', 'true');
        } else {
          $(".l-nav__btn.js-gnav").attr('aria-expanded', 'true');
          $(".l-nav__body").attr('aria-hidden', 'false');
        }
      }
    });

    // アコーディオンパーツ
    $('.c-accordion__ttl').on('click', function () {
      $(this).next('.c-accordion__text').slideToggle();
      $(this).toggleClass('js-accordion__open');
      $(this).parent().toggleClass('js-acc__parent');
      if ($(this).attr('aria-expanded') == 'true') {
        $(this).attr('aria-expanded', 'false');
        $(this).next(".c-accordion__text").attr('aria-hidden', 'true');
      } else {
        $(this).attr('aria-expanded', 'true');
        $(this).next(".c-accordion__text").attr('aria-hidden', 'false');
      }
    });

    // フローティングバナー用 スクロールで要素にclass追加
    $(window).on('load scroll', function () {
      var height = $(document).height()

      if ($(window).scrollTop() > height / 3) {
        $('.c-bnr-floating').addClass('js-flo-active');
      } else {
        $('.c-bnr-floating').removeClass("js-flo-active");
      }
    });

    $('.c-bnr-floating .bnr-close').on('click', function () {
      $('.c-bnr-floating').addClass('js-flo-close');
    });

    // ofi
    objectFitImages();

    // top bnr slider
    $('.js-bnr-slider').infiniteslide({
      'speed': 50,
      'direction': 'left',
      'pauseonhover': false,
      'responsive': true,
      'clone': 4
    });


  });

})(jQuery);
